/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Todo_FilterInputs */

const en_todo_filter = /** @type {(inputs: Todo_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To do`)
};

/**
* | output |
* | --- |
* | "To do" |
*
* @param {Todo_FilterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const todo_filter = /** @type {((inputs?: Todo_FilterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Todo_FilterInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_todo_filter(inputs)
});